// extracted by mini-css-extract-plugin
export default {"actions":"POS__actions--JTSaN","labelTotal":"POS__labelTotal--Ei7YJ","left":"POS__left--edSoo"};